var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatFooterButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.59961 9.7998C6.59961 9.24752 7.04732 8.7998 7.59961 8.7998H16.3996C16.9519 8.7998 17.3996 9.24752 17.3996 9.7998C17.3996 10.3521 16.9519 10.7998 16.3996 10.7998H7.59961C7.04732 10.7998 6.59961 10.3521 6.59961 9.7998Z",
    fill: "#127050"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.59961 14.2002C6.59961 13.6479 7.04732 13.2002 7.59961 13.2002H11.9996C12.5519 13.2002 12.9996 13.6479 12.9996 14.2002C12.9996 14.7525 12.5519 15.2002 11.9996 15.2002H7.59961C7.04732 15.2002 6.59961 14.7525 6.59961 14.2002Z",
    fill: "#127050"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C9.95031 24 8.01812 23.4853 6.32839 22.5776L1.73303 23.4331C1.40896 23.4934 1.07598 23.3902 0.842892 23.1571C0.609804 22.924 0.506558 22.591 0.566894 22.267L1.42247 17.6716C0.514706 15.9819 0 14.0497 0 12ZM12 2C6.47715 2 2 6.47715 2 12C2 13.8231 2.48695 15.5294 3.33721 16.9993C3.45672 17.2059 3.49839 17.4484 3.45471 17.683L2.79989 21.2001L6.31697 20.5453C6.5516 20.5016 6.79411 20.5433 7.0007 20.6628C8.47058 21.513 10.177 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2Z",
    fill: "#127050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatFooterButton);
export default __webpack_public_path__ + "static/media/chat-footer-button.a1b97215c4c90217ce150f805be4095c.svg";
export { ForwardRef as ReactComponent };